<template>
  <MainLayout selectMenu="1-1" sideBar="machine" siderMenu="14-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <!-- 自定义Tab切换 -->
      <div v-if="loading" >
          <LoadingBar :height="'500px'"/>
      </div>
      <div class="custom-tabs" v-else>
        <div class="custom-tabs-nav">
          <div
            v-for="tab in visibleTabs"
            :key="tab.name"
            :class="['custom-tab-item', { 'custom-tab-active': mode === tab.name }]"
            @click="handleTabClick(tab.name)"
          >
            {{ getTranslation(tab.label) }}
          </div>
        </div>
        <div class="custom-tabs-content">
          <!-- Tab 0: 系统设置 -->
          <div v-if="mode === 'm0'" class="custom-tabpane">
          <Card class="card-container " dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('k037') }}</div>
            <Row class="limit-line table-row-odd" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k038') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptMachineType" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptMachineTypeList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k061') }}</Col>
                <Col flex="2"><Select :transfer="true" :value="OptVoltage(kind)" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option value="450" key="450" selected v-if="KindOf803(kind) || KindOf802(kind)">450</Option>
                  <Option value="300" key="300" selected v-if="KindOf62(kind)">300</Option>
                </Select>&nbsp;V</Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line table-row-odd" type="flex">
                <template v-if="KindOf803(kind)">
                  <Col flex="1" class="left-program desc-field">{{ getTranslation('k122') }}</Col>
                  <Col flex="2"><Select :transfer="true" v-model="info.OptRsv163" class="input-field"
                    :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                    <Option v-for="(item, key) in OptRsv163List" :value="key" :key="key">{{ item }}</Option>
                  </Select></Col>
                </template>
                <template v-else>
                  <Col flex="1" class="left-program desc-field">{{ getTranslation('k122') }}</Col>
                  <Col flex="2"><Input v-model="info.NumInverter" type="number" class="input-field" />

                  </Col>
                </template>
              </Row>
              </Col>
            </Row>

            <Row class="limit-line" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k047') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptSpotSureFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k062') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptContinueWledFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k123') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptEnableWeldFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
            </Row>

            <Row class="limit-line table-row-odd" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k050') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptTransformerType" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptTransformerTypeList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k063') }}</Col>
                <Col flex="2"><Input class="input-field" v-model="info.OptCurrentFeedback" disabled></Input>&nbsp;V
                </Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k124') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.CrrMaxSecondary" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in CrrMaxSecondaryList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
            </Row>

            <Row class="limit-line" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k051') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptElectrodeDressSure" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k064') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptCurrConstMode" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptCurrConstModeList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k125') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptElectrodePressMode" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptElectrodePressModeList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
            </Row>

            <Row class="limit-line table-row-odd" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k052') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptWeldFinishSignal" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptWeldFinishSignalList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k067') }}</Col>
                <Col flex="2"><Input class="input-field" type="number" v-model="info.PssMaxElect" />&nbsp;KN</Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k126') }}</Col>
                <Col flex="2"><Input class="input-field" type="number" v-model="info.TimMaxWeld" />
                &nbsp;<template v-if="KindOf62(kind)">cyc</template><template v-else>ms</template>
                </Col>
              </Row>
              </Col>
            </Row>

            <Row class="limit-line" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k055') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptRsv166" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptRsv166List" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k068') }}</Col>
                <Col flex="2"><Input class="input-field" type="number" v-model="info.OptRsv168" />&nbsp;Hz</Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k127') }}</Col>
                <Col flex="2"><Input class="input-field" type="number" v-model="info.OptRsv164" />&nbsp;%</Col>
              </Row>
              </Col>
            </Row>
            <Row class="limit-line table-row-odd" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k058') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.ValTrigAngle" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in ValTrigAngleList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
                <Row class="limit-line" type="flex" v-if="KindOf803(kind)">
                <Col flex="1" class="left-program desc-field" ><div class="important-col">{{ getTranslation('s349') }}</div></Col>
                <Col flex="2" ><Select :transfer="true" v-model="info.OptWONewSpotSelFunc" class="input-field important-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1" >
                
              </Col>
            </Row>
          </Card>
          <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('k069') }}</div>
            <Row class="limit-line table-row-odd" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k070') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptHmiEstopFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k071') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptPVFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k131') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptIoCtrlFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptIoCtrlFuncList" :value="key" :key="key">{{ item }}</Option>

                </Select></Col>
              </Row>
              </Col>
            </Row>

            <Row class="limit-line" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k140') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptProgNoPriorFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptProgNoPriorFuncList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k073') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptRunOffLineFunc" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('k137') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptIOMode" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in OptIOModeList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
            </Row>

            <Row class="limit-line table-row-odd" type="flex">
              <Col flex="1">
              <Row class="limit-line" type="flex">
                <Col flex="1" class="left-program desc-field">{{ getTranslation('s077') }}</Col>
                <Col flex="2"><Select :transfer="true" v-model="info.OptIGBTResetControl" class="input-field"
                  :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                  <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                </Select></Col>
              </Row>
              </Col>
              <Col flex="1">            
              </Col>
              <Col flex="1">            
              </Col>
            </Row>


          </Card>
          <div class="menu-actions">
            <Button type="primary" size="small" icon="md-download" @click.native="downloadSystem()">{{ getTranslation('k023')}}</Button>&nbsp;
          </div>
          </div>
          <!-- Tab 1: 焊接设置 -->
          <div v-if="mode === 'm1' && info && info.OptMachineType!==undefined && (info.OptMachineType == 1 || info.OptMachineType == 4)" class="custom-tabpane">
            <WeldingSetting :kind="kind" :OptMachineType="info.OptMachineType"></WeldingSetting>
          </div>
          <!-- Tab 2: 校准1 -->
          <div v-show="mode === 'm2'" class="custom-tabpane" v-if="KindOf803(kind) || KindOf802(kind) || KindOf62(kind)">
            <CalibrationOne :kind="kind" ref="calibrationOne" :mode="mode" ></CalibrationOne>
          </div>
          <!-- Tab 3: 校准2 -->
          <div v-show="mode === 'm3'" class="custom-tabpane" v-if="KindOf803(kind) || KindOf802(kind) || KindOf62(kind)">
            <CalibrationTwo :kind="kind" ref="calibrationTwo" :mode="mode"></CalibrationTwo>
          </div>
          <!-- Tab 4: 校准3 -->
          <div v-show="mode === 'm4'" class="custom-tabpane" v-if="KindOf803(kind) || KindOf802(kind) ">
            <CalibrationThree :kind="kind" ref="calibrationThree" :mode="mode"></CalibrationThree>
          </div>
          <!-- Tab 5: 校准4 -->
          <div v-show="mode === 'm5'" class="custom-tabpane" v-if="KindOf803(kind) || KindOf802(kind)">
            <CalibrationFour :kind="kind" ref="calibrationFour" :mode="mode"></CalibrationFour>
          </div>
          <!-- Tab 6: 校准5 -->
          <div v-show="mode === 'm6'" class="custom-tabpane" v-if="KindOf803(kind) || KindOf802(kind)">
            <CalibrationFive :kind="kind" ref="calibrationFive" :mode="mode"></CalibrationFive>
          </div>
          <!-- Tab 7: UIR设置 -->
          <div v-if="mode === 'm7' && KindOf803(kind)" class="custom-tabpane">
            <UirSetting :kind="kind"></UirSetting>
          </div>
          <!-- Tab 8: UIR线路 -->
          <div v-if="mode === 'm8' && KindOf803(kind)" class="custom-tabpane">
            <UirLine :kind="kind"></UirLine>
          </div>
          <!-- Tab 9: UIP设置 -->
          <div v-if="mode === 'm9' && KindOf803(kind)" class="custom-tabpane">
            <UipSetting :kind="kind" :programSize="programSize"></UipSetting>
          </div>
          <!-- Tab 10: UIP线路 -->
          <div v-if="mode === 'm10' && KindOf803(kind)" class="custom-tabpane">
            <UipLine :kind="kind" :programSize="programSize"></UipLine>
          </div>
          <!-- Tab 11: 软件升级 -->
          <div v-if="mode === 'm11'" class="custom-tabpane">
            <SoftUpgrade :kind="kind" :progress="progress"></SoftUpgrade>
          </div>
          <!-- Tab 12: 系统备份 -->
          <div v-if="mode === 'm12'" class="custom-tabpane">
            <SystemBackup :kind="kind"></SystemBackup>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import MainLayout from '@/components/MainLayout.vue'
import { Card, Row, Col, Button, Select, Option, Input } from "view-design"
import WeldingSetting from './components/WeldingSetting.vue';
import CalibrationOne from './components/CalibrationOne.vue';
import CalibrationTwo from './components/CalibrationTwo.vue';
import CalibrationThree from './components/CalibrationThree.vue';
import CalibrationFour from './components/CalibrationFour.vue';
import CalibrationFive from './components/CalibrationFive.vue';
import UirSetting from './components/UirSetting.vue';
import UirLine from './components/UirLine.vue';
import UipSetting from './components/UipSetting.vue';
import UipLine from './components/UipLine.vue';
import SoftUpgrade from './components/SoftUpgrade.vue';
import SystemBackup from './components/SystemBackup.vue';
import { setSidbarBreadCrumb, postJsError, setDashboardPage,KindOf803,KindOf802,KindOf62 } from '@/util/util.js';
import { mapGetters } from 'vuex'
import NoAuth from '@/components/NoAuth.vue'
import LoadingBar from '@/components/LoadingBar.vue'
export default {
  name: 'SystemIndex', // 组件名称
  components: {
    MainLayout, Card, Row, Col, Button, Select, Option, Input, CalibrationOne, CalibrationTwo,CalibrationThree,CalibrationFour,CalibrationFive,UirSetting,
    UipSetting, SoftUpgrade, SystemBackup, UirLine, UipLine, WeldingSetting, NoAuth,LoadingBar
  },
  computed: {
    ...mapGetters(['getTranslation']),
    OptMachineTypeList() {
      let rs =[
        this.getTranslation("k039"),
        this.getTranslation("k040"),
        this.getTranslation("k041"),
        this.getTranslation("k042"),
        this.getTranslation("k043"),
        this.getTranslation("k044"),
        this.getTranslation("k045"),        
      ];
      if (KindOf803(this.kind)) {
        rs.push(this.getTranslation("k046"),)
      }
      return rs;

    },
    OptRsv163List() {
      return [
        this.getTranslation("k128"),
        this.getTranslation("k129"),
        this.getTranslation("k130"),
      ]
    },
    SwitchList() {
      return [
        this.getTranslation("k048"),
        this.getTranslation("k049"),
      ]
    },
    OptTransformerTypeList() {
      if (KindOf803(this.kind) || KindOf802(this.kind)) {
        return [
          "25KVA",
          "55KVA",
          "75KVA",
          "110KVA",
          "165KVA",
          "220KVA",
          "250KVA",
          "330KVA",
          "440KVA",
          "660KVA",
          "880KVA",
          "1250KVA",
          "2500KVA",
        ]
      } else {
        return [
          "25KVA",
          "55KVA",
          "75KVA",
          "110KVA",
          "165KVA",
          "220KVA",
          "250KVA",
          "330KVA",
          "440KVA",
          "660KVA",
          "880KVA",
          "1250KVA",]
      }
    },
    CrrMaxSecondaryList() {
      return [
        "20KA",
        "30KA",
        "60KA",
        "200KA",
      ]
    },
    OptCurrConstModeList() {
      return [
        this.getTranslation("k065"),
        this.getTranslation("k066"),
      ]
    },
    OptElectrodePressModeList() {
      return [
        "%",
        "KN"
      ]
    },

    OptWeldFinishSignalList() {
      return [
        this.getTranslation("k053"),
        this.getTranslation("k054"),
      ]
    },
    OptRsv166List() {
      return [
        this.getTranslation("k056"),
        this.getTranslation("k057"),
      ]
    },
    ValTrigAngleList() {
      return [
        this.getTranslation("k059"),
        this.getTranslation("k060"),
      ]
    },
    OptIoCtrlFuncList() {
      //notice 这个区别很大
      if (KindOf803(this.kind)) {
        return [
          this.getTranslation("k132"),
          this.getTranslation("k133"),
          this.getTranslation("k134"),
          this.getTranslation("k135"),
          this.getTranslation("k136"),
        ]
      } else {
        return [
          this.getTranslation("k132"),
          this.getTranslation("k138"),
          this.getTranslation("k133"),
          this.getTranslation("k134"),
          this.getTranslation("k135"),
          this.getTranslation("k136"),
        ]
      }
    },
    OptProgNoPriorFuncList() {
      return [
        this.getTranslation("k132"),
        this.getTranslation("k138"),
        this.getTranslation("k133"),
        this.getTranslation("k134"),
        this.getTranslation("k135"),
        this.getTranslation("k136"),
      ]
    },
    OptIOModeList() {
      return [
        this.getTranslation("k132"),
        this.getTranslation("k138"),
        this.getTranslation("k139"),
      ]
    },
    visibleTabs() {
      return this.tabs.filter(tab => {
        // 根据条件过滤显示的tab
        if (tab.name === 'm1') {
          // 焊接设置tab只在特定条件下显示
          return this.info && this.info.OptMachineType !== undefined &&
                 (this.info.OptMachineType == 1 || this.info.OptMachineType == 4);
        } else if ( tab.name === 'm2' || tab.name === 'm3' || tab.name === 'm4' || tab.name === 'm5' || tab.name === 'm6'){
          if(tab.name === 'm2' || tab.name === 'm3'){
            return KindOf803(this.kind) || KindOf802(this.kind) ||  KindOf62(this.kind);
          }
          return KindOf803(this.kind) || KindOf802(this.kind) ;
        } else if (tab.name === 'm7' || tab.name === 'm8' || tab.name === 'm9' || tab.name === 'm10' || tab.name === 'm11') {
          // UIR/UIP相关tab只在kind=803时显示
          return KindOf803(this.kind) ;
        }
        return true; // 其他tab默认显示
      });
    }
  },
  data() {
    return {
      // 响应式数据
      kind: 0,//机器类型
      programSize: 0,//规范大小
      mode: 'm0',
      info: {},
      progress: 0,
      hasAuth: true,
      previousMode: 0, // 保存切换前的mode值
      tabs: [
        { name: 'm0', label: 'k004' },
        { name: 'm1', label: 'k360' },
        { name: 'm2', label: 'k027' },
        { name: 'm3', label: 'k028' },
        { name: 'm4', label: 'k029' },
        { name: 'm5', label: 'k030' },
        { name: 'm6', label: 'k031' },
        { name: 'm7', label: 'k032' },
        { name: 'm8', label: 'k033' },
        { name: 'm9', label: 'k141' },
        { name: 'm10', label: 'k034' },
        { name: 'm11', label: 'k035' },
        { name: 'm12', label: 'k036' }
      ],
      loading:true
    }
  },
  mounted() {
     window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  async created() {
    this.loading=true;
    // 生命周期钩子 - 实例创建后
    await this.init();
    this.loading = false;
    setDashboardPage('system');
    this.mode = localStorage.getItem('system.tab') || 'm0';   
    if (this.mode === 'm1' && !(this.info && this.info.OptMachineType !== undefined && (this.info.OptMachineType == 1 || this.info.OptMachineType == 4))){    
      this.mode = 'm0';
    }   
    if (!KindOf803(this.kind)  && (this.mode === 'm2' || this.mode === 'm3'
    || this.mode === 'm4'|| this.mode === 'm5'|| this.mode === 'm6'|| this.mode === 'm7'|| this.mode === 'm8'
    || this.mode === 'm9'|| this.mode === 'm10') ){
      this.mode = 'm0';
    }
    // 初始化previousMode
    this.previousMode = this.mode;
  },
  beforeDestroy() { 
    window.removeEventListener('beforeunload', this.handleBeforeUnload);  
  },
  methods: {
    // 方法定义
    async init() {      
      let url = API_URL["programInit"];
      this.mac = this.$route.query.mac
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac
      }
      let res = await axios.get(url, {
        params: params
      })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      
        if (res && res.data && res.data.code == 200) {
          this.kind = res.data.data.kind;
          this.programSize = res.data.data.size || 0;
          await this.getSystemInfo();
        } else if (res && res.data && res.data.code == 3001) {
          this.hasAuth = false;
        } else if (res && res.data && res.data.msg) {
          this.$Message.error(res.data.msg);
        }
        
    },
    handleBeforeUnload(event) {
      if(!this.calCanJump()){
        event.preventDefault();
        event.returnValue = this.getTranslation('s332');
      }
    },
    async getSystemInfo() {
      let url = API_URL["systemInfo"];
      this.mac = this.$route.query.mac
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac
      }
      let res = await axios.get(url, {
        params: params
      })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      if (res && res.data && res.data.code == 200) {
        this.info = res.data.data.param;
          this.progress = res.data.data.progress;

          this.$store.commit('setBreadcrumbItems', [
            { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
          ]);
          //this.$Message.success(res.data.msg);
        } else if (res && res.data && res.data.msg) {
          this.$Message.error(res.data.msg);
        }
      
        
    },
    downloadSystem() {
      let url = API_URL["SystemParamDownload"] + '?mac=' + this.mac
      let params = new FormData();
      this.info && Object.keys(this.info).forEach(key => {
        params.append(key, this.info[key]);
      });
      axios.post(url,
        params
      )
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    calCanJump(targetMode){
      let rs = true;
      // 如果targetMode未提供，使用当前mode；如果提供了，使用targetMode
      const checkMode = targetMode !== undefined ? targetMode : this.mode;
      if(checkMode == 'm2' && this.$refs.calibrationOne && !this.$refs.calibrationOne.canJump){
        rs = false;
      }
      if(checkMode == 'm3' && this.$refs.calibrationTwo && !this.$refs.calibrationTwo.canJump){
        rs = false;
      }
      if(checkMode == 'm4' && this.$refs.calibrationThree && !this.$refs.calibrationThree.canJump){
        rs = false;
      }
      if(checkMode == 'm5' && this.$refs.calibrationFour && !this.$refs.calibrationFour.canJump){
        rs = false;
      }
      if(checkMode == 'm6' && this.$refs.calibrationFive && !this.$refs.calibrationFive.canJump){
        rs = false;
      }
      return rs;

    },
    handleTabClick(tabName) {
      // 检查当前模式是否可以跳转
      if (!this.calCanJump(this.mode)) {        
        this.$Message.warning(this.getTranslation('s332')); // 添加用户提示
        return; // 阻止切换
      }      
      // 允许切换      
      localStorage.setItem('system.tab',tabName)
      this.mode = tabName;
    },
    KindOf62(kind){
      return KindOf62(kind);
    },
    KindOf803(kind){
      return KindOf803(kind);
    },
    KindOf802(kind){
      return KindOf802(kind);
    },
    OptVoltage(kind){      
      let rs = '450';
      if (KindOf803(kind) || KindOf802(kind)) {
        rs = '450';
      } else if (KindOf62(kind)) {
        rs = '300';
      }
      return rs;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 检查当前是否在校准页面且正在校准中    
    if (!this.calCanJump()) {
      this.$Message.warning(this.getTranslation('s332'));
      next(false);
    } else {
      next();
    }
  }
}
</script>

<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');
/* 针对 disabled Input 组件的样式 */
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
  color: #999 !important;
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #999 !important;
}
.important-col{
  background-color: #FFFF00;
  padding:4px 8px;
}


.important-field ::v-deep .ivu-select-selection {
  background-color: #FFFF00;
}

</style>